export const BASE_URL = 'https://api.sojiapps.com/api/v1';
